import { Order, OrderStatus, StatusVariant } from '@/types/order'

interface OrderSortParam {
  id: string
  desc: boolean
}

export const getOrderSortParams = (order: OrderSortParam[]) => {
  const nullableIds = ['.country', 'price_list.name', 'email']

  console.log('order', order)

  const getSortParam = (id: string, desc: boolean) => {
    if (nullableIds.some(nullableId => id.includes(nullableId))) {
      return desc ? 'desc' : 'asc'
    } else {
      return {
        sort: desc ? 'desc' : 'asc',
      }
    }
  }

  return order.map(o => {
    if (o.id.includes('.')) {
      return {
        [o.id.split('.')[0]]: {
          [o.id.split('.')[1]]: getSortParam(o.id, o.desc),
        },
      }
    } else {
      return {
        [o.id]: getSortParam(o.id, o.desc),
      }
    }
  })
}

export const orderStatuses = {
  AWAITING_SINCHRONIZATION: 'Submitted',
  MANUFACTURING: 'Manufacturing',
  AWAITING_CONFIRMATION: 'Needs Confirmation',
  ERROR: 'Error',
  CANCELLED: 'Cancelled',
  AWAITING_PAYMENT: 'Waiting for payment',
  PAYMENT_COMPLETED: 'Payment completed',
  REFUNDED: 'Refunded',
  PARTIALLY_DELIVERED: 'Partially delivered',
  COMPLETED: 'Dispatched',
}

export const getStatusVariant = (status: OrderStatus): StatusVariant => {
  switch (status) {
    case 'COMPLETED':
      return 'green'
    case 'ERROR':
      return 'destructive'
    case 'CANCELLED':
      return 'outline'
    case 'AWAITING_PAYMENT':
    case 'AWAITING_CONFIRMATION':
    case 'AWAITING_SINCHRONIZATION':
    case 'MANUFACTURING':
      return 'lightBlue'
    case 'PAYMENT_COMPLETED':
    case 'PARTIALLY_DELIVERED':
      return 'outline'
    default:
      return 'outline'
  }
}

export const formatDate = (date: string, showTime: boolean = false): string => {
  return new Date(date).toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',

    ...(showTime && {
      hour: '2-digit',
      minute: '2-digit',
    }),
  })
}

export const calculateOrderVolume = (
  orderOrItems: Order | Order['order_items']
): number => {
  const items = Array.isArray(orderOrItems)
    ? orderOrItems
    : orderOrItems.order_items
  return items.reduce((total, item) => {
    return total + (item.volume || 0)
  }, 0)
}
